import { ButtonVariant } from '@/shared/components/Button/Button';

export const ExploreButtonConfig: { buttonType: ButtonVariant } = {
    buttonType: 'accent',
};
